export const order = {
  ALL: 'Todo',
  LIST: 'Lista',
  COMPACT: 'Compacto',
  ORDER: 'Ordenar',
  ORDER_LIST: 'Ordenar lista',
  VIEW: 'Vista',
  'More options for': 'Más opciones para',
};
